import type { TagOption } from './types';

type ContentModelMember = { id?: string | null; name?: string | null };

// A proposal can name metadata with no record yet — Rails creates it on accept — so key the
// member by name until then and the id-driven controls show it like any other tag.
const PENDING_ID_PREFIX = 'pending:';

function toMembers(members: unknown): ContentModelMember[] {
  return Array.isArray(members) ? (members as ContentModelMember[]) : [];
}

function memberTagId(member: ContentModelMember): string | null {
  if (member.id) return member.id;

  const name = member.name?.trim();
  return name ? `${PENDING_ID_PREFIX}${name.toLowerCase()}` : null;
}

export function isPendingTagId(id: string): boolean {
  return id.startsWith(PENDING_ID_PREFIX);
}

export function memberTagOptions(members: unknown): TagOption[] {
  return toMembers(members).flatMap((member) => {
    const id = memberTagId(member);
    const name = member.name?.trim();
    return id && name ? [{ id, name }] : [];
  });
}

export function memberTagIds(members: unknown): string[] {
  return memberTagOptions(members).map((option) => option.id);
}
